import gql from 'graphql-tag';

export const GET_BROADSHEET_TEMPLATES = gql`
    query GetBroadsheetTemplates {
        broadsheetTemplates(first: 100) {
            data {
                id
                name
                description
                properties
                school {
                    id
                    name
                }
                columns {
                    id
                    label
                    key
                    type
                    sequence
                    is_visible
                    calculation_function
                    calculation_arguments
                }
            }
        }
    }
`;

export const GET_BROADSHEET_REPORT = gql`
    query GetBroadsheet(
        $classId: ID
        $calId: ID!
        $templateId: ID!
        $programmeId: ID
        $level: String
        $student_status: String
    ) {
        broadsheetReport(
            classroom_id: $classId
            academic_calendar_id: $calId
            broadsheet_template_id: $templateId
            programme_id: $programmeId
            level: $level
            student_status: $student_status
        ) {
            headers
            data
            summary
            course_legend
            grade_legend
            meta {
                program_name
                department_name
                faculty_name
                session
                semester
                level
                classroom_name
            }
        }
    }
`;

export const GET_BROADSHEET_EXCEL_URL = gql`
    query GetBroadsheetExcelUrl(
        $classId: ID
        $calId: ID!
        $templateId: ID!
        $sectionId: ID
        $programmeId: ID
        $level: String
        $student_status: String
    ) {
        broadsheetExcelUrl(
            classroom_id: $classId
            academic_calendar_id: $calId
            broadsheet_template_id: $templateId
            section_id: $sectionId
            programme_id: $programmeId
            level: $level
            student_status: $student_status
        ) {
            id
            type
            status
            progress
            file_name
            error_message
            created_at
        }
    }
`;

export const GET_BROADSHEET_PDF_URL = gql`
    query GetBroadsheetPdfUrl(
        $classId: ID
        $calId: ID!
        $templateId: ID!
        $sectionId: ID
        $programmeId: ID
        $level: String
        $student_status: String
    ) {
        broadsheetPdfUrl(
            classroom_id: $classId
            academic_calendar_id: $calId
            broadsheet_template_id: $templateId
            section_id: $sectionId
            programme_id: $programmeId
            level: $level
            student_status: $student_status
        ) {
            id
            type
            status
            progress
            file_name
            error_message
            created_at
        }
    }
`;
